$(function(){

  // gnav
  $(".header__gnav__btn").click(function () {
    $(this).toggleClass('active');
    $("#gnav").toggleClass('panelactive');
    $("#main-wrapper").toggleClass('panelactive');
  });
  $("#gnav a").click(function () {
    $(".header__gnav__btn").removeClass('active');
    $("#gnav").removeClass('panelactive');
    $("#main-wrapper").removeClass('panelactive');
  });
  $(".main-wrapper__bg").click(function () {
    $(".header__gnav__btn").removeClass('active');
    $("#gnav").removeClass('panelactive');
    $("#main-wrapper").removeClass('panelactive');
  });

  // バナー非表示ボタン
  var isBnrHidden = false;
  $("#bnr-close").click(function () {
    $('#bnr-fix').hide();
    isBnrHidden = true;
  });

  $(window).on("load", function () {
    var introTOP = $("#bnr-start").offset().top;
    console.log('start');
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      //console.log(scroll);
      //console.log(introTOP);
      if (scroll >= introTOP && !isBnrHidden) {
        $("#bnr-fix").fadeIn();
      } else {
        $("#bnr-fix").fadeOut();

      }
    });
  });



  // スクロールで出現させる。
  var scrollAnimationElm = document.querySelectorAll('.scroll_view , .scroll_up , .scroll_left , .scroll_right');
  var scrollAnimationFunc = function () {
    for (var i = 0; i < scrollAnimationElm.length; i++) {
      var triggerMargin = 80;
      if (window.innerHeight > scrollAnimationElm[i].getBoundingClientRect().top + triggerMargin) {
        scrollAnimationElm[i].classList.add('on');
      }
    }
  }
  window.addEventListener('load', scrollAnimationFunc);
  $(window).scroll(function () {
    window.addEventListener('scroll', scrollAnimationFunc);
  });

});
